import { DEFAULT_TABLE_PAGE_SIZE } from 'src/constants/Pagination';
import { JmrFlowTypes, JmrJobTypes, JmrPageProgress } from 'src/utils/jmrUtils';

import { type Site } from '../siteSlice';
import { ApiCallStatus } from '../type';

import { type BackgroundFormData, type BackgroundFormFieldLength, type JmrPageState } from './types';

export const initialBackgroundFormData: BackgroundFormData = {
  alias: '',
  fullName: '',
  job: '',
  employeeID: '',
  shift: '',
  caseID: '',
  caseSource: '',
  managerName: '',
  managerAlias: '',
  cannotWorkNormalShiftHrs: false,
  cannotWorkMoreThan40Hrs: false,
  indefiniteRestrictions: false,
  providerPlacedOffWork: false,
  siteLocation: '',
  site: {} as Site,
  personId: '',
  country: '',
  shiftLength: 0,
  restrictionStartDate: '',
  restrictionEndDate: '',
  limitedHoursPerDay: '',
  limitedHoursPerWeek: '',
  caseIdValid: false,
  accommodationStatus: '',
  jobLevel: null,
};

export const backgroundFormFieldLengthValues: BackgroundFormFieldLength = {
  maxAliasLength: 255,
  maxFullNameLength: 150,
  maxJobLength: 150,
  maxEmployeeIdLength: 150,
  maxShiftCodeLength: 150,
  maxManagerAliasLength: 150,
  maxManagerNameLength: 150,
  maxCaseIdLength: 255,
};

export const initialState: JmrPageState = {
  t2AdminToggle: null,
  pageProgress: JmrPageProgress.Background,
  isCancelModalOpen: false,
  backgroundFormData: initialBackgroundFormData,
  backgroundFormErrors: {},
  backgroundFormFieldLengths: backgroundFormFieldLengthValues,
  regionTasks: [],
  consolidatedRegionTasks: [],
  selectedTaskNames: [],
  selectedTasks: [],
  restrictionsFormErrors: {},
  jmrResults: [],
  jmrFilter: {
    searchField: '',
    currentPage: 1,
    totalPages: 1,
    perPage: DEFAULT_TABLE_PAGE_SIZE,
    jobType: JmrJobTypes.ProcessPath,
  },
  approvalFormData: { emailContent: '', emailRecipients: '' },
  approvalFormErrors: {},
  isResultsPageValid: false,
  isRestrictionsModalOpen: undefined,
  createdAccommodationId: -1,
  jmrFlowType: JmrFlowTypes.CreateNewAccommodation,
  placementId: 0,
  accommodationSavingStatus: ApiCallStatus.Idle,
  austinCases: [],
  searchedAlias: '',
  isLoadingPAPI: false,
  isLoadingIncident: false,
  isLoadingGetPlacementDetails: false,
  isAUSTINDown: false,
  areAustinCasesFetched: false,
  processingMessages: [],
  externalCaseId: '',
  accommodationType: '',
  showCaseIdRequiredText: false,
  // The userSlice is the source for this. In order to share that value with this newJmrSlice,
  // app.tsx dispatches an async thunk action. This is done cause we can't use another redux
  // slice's state directly in a different redux slice.
  dpFeatureFlag: false,
  isProviderPlacedOffWorkModalOpen: false,
  tldAlertModal: {
    hasBeenOpened: false,
    resultId: '',
    jobId: -1,
    open: false,
  },
  restrictionListItems: [],
  isRestrictionsPageReadOnly: false,
  isUsingNewExperience: true,
  // only relevant in update JMR scenarios
  currentPlacementJobShifts: [],
};
